module.exports = __webpack_public_path__ + "media/images/social/telegram-brands-41d20e008733c5e1faaa66d6838604ea.svg";